import React from "react";
import Hero from "./Hero";
import Options from "./Options";

function CarrerPage() {
  return (
    <>
      <Hero />
      <Options />
    </>
  );
}

export default CarrerPage;
